import { createFileRoute } from '@tanstack/react-router';
import { UsersPage } from '../../features/settings/components/users-page.js';

export const Route = createFileRoute('/admin/users')({ component: UsersPage });
